export const SUGGEST_TO_REJECT_COMPANY_MODAL_LABELS = {
  TITLE: 'Update third-party status to ‘Rejected’?',
  DESCRIPTION:
    'All assessments for this third-party are complete. One assessment has concluded with a ‘Rejected’ status. Would you like to update their status accordingly?',
  CANCEL: 'Keep as approved',
  CONFIRM: 'Reject',
} as const
